<script setup lang="ts">
import { onUnmounted, watch } from 'vue'
import type { IBlanketProps } from './types'
import { EVariants } from './types'
import { disableScroll, enableScroll, isDark } from '@/lib/utils'

const props = withDefaults(defineProps<IBlanketProps>(), {
    isOpen: false,
    dark: false,
    variant: EVariants.DEFAULT,
})

defineEmits<{
    (e: 'blanketClick'): void
}>()

const variants = {
    [EVariants.DEFAULT]: 'bg-neutral-overlay',
    [EVariants.STRONG]: 'bg-neutral-overlay-strong',
}

watch(
    () => props.isOpen,
    () => (props.isOpen ? disableScroll() : enableScroll()),
)

onUnmounted(() => {
    enableScroll()
})
</script>

<template>
    <div
        class="fixed inset-0 z-50 transition-all duration-200 ease-linear"
        :class="[
            isDark(dark),
            isOpen ? 'visible opacity-100 backdrop-blur-md' : 'invisible opacity-0 backdrop-blur-none',
            variants[variant],
        ]"
        :data-test="`blanket-${dataTest}`"
        data-gpp-tools-ui
        @click="$emit('blanketClick')"
    />
</template>
